import axios, { client2 } from "@/config/axios-wrapper";
import { Meeting } from "@/types/meeting";
import { ParseResumeResponse } from "@/types/resume";
import { Jobseeker, OnboardingStats } from "@/types/user";

export const getUserNotifications = async (
  data: { userId: string },
  options: { cursor?: string },
) => {
  const response = await axios.get(
    `${`/users/${data.userId}`}/notifications${options.cursor ? `?cursor=${options.cursor}` : ""}`,
  );

  return response.data;
};

export const loginUserWithEmailAndPassword = async (data: { email: string; password: string }) => {
  const response = await axios.post("/users/login", data);
  return response.data;
};

export const getUser = async (userId: string) => {
  const response = await axios.get(`/users/${userId}`);
  return response.data;
};

export const deleteUser = async (userId: string,data: { reason: string; } ) => {
  const response = await client2.post(`/users/${userId}/delete`, data);
  return response.data;
};

export const getJobseeker = async (userId: string) => {
  const response = await axios.get<Jobseeker>(`/users/${userId}`);
  return response.data;
};

export const getEmployer = async (userId: string) => {
  const response = await axios.get<{
    id: string;
    full_name: string;
    email: string;
    type: string;
    photo: string;
    job_title: string;
    address?: {
      line1: string;
      line2: string;
      country: string;
      state: string;
      city: string;
      zip_code: string;
    };
    organization?: {
      id: string;
      name: string;
      tax_id: string;
      logo: string;
    };
    organization_owner?: boolean;
    permissions: string[];
    password_changed: boolean;
  }>(`/users/${userId}`);
  return response.data;
};

export const uploadUserVideo = async (userId: string, formData) => {
  const response = await axios.post(`/users/${userId}/video`, formData);
  return response.data;
};

export const deleteUserVideo = async (userId: string) => {
  const response = await axios.delete(`/users/${userId}/video`);
  return response.data;
};

export const uploadUserResume = async (userId: string, formData: FormData) => {
  const response = await axios.post(`/users/${userId}/resume`, formData);
  return response.data;
};

export const deleteUserResume = async (userId: string) => {
  const response = await axios.delete(`/users/${userId}/resume`);
  return response.data;
};

export const updateUser = async (userId: string, data: any) => {
  const response = await axios.put(`/users/${userId}`, data);
  return response.data;
};

export const updateUser2 = async ({ id, data }: { id: string; data: any }) => {
  const response = await axios.put(`/users/${id}`, data);
  return response.data;
};

export const uploadUserPhoto = async (userId: string, formData) => {
  const response = await axios.post<{ photo: string; photo_thumbnail_url: string }>(
    `/users/${userId}/photo`,
    formData,
  );
  return response.data;
};

export const getOnboardingStats = async (userId: string) => {
  const response = await axios.get<OnboardingStats>(`/users/${userId}/onboarding-stats`);
  return response.data;
};

export const sendChangeEmailOtp = async (userId: string, data: { email: string }) => {
  const response = await axios.post(`/users/${userId}/change-email/send-otp`, data);
  return response.data as { token: string };
};

export const verifyChangeEmailOtp = async (
  userId: string,
  data: { token: string; otp: string },
) => {
  return await axios.post(`/users/${userId}/change-email/verify-otp`, data);
};

export const changeUserPassword = async (
  userId: string,
  data: { old_password: string; new_password: string },
) => {
  const response = await axios.post(`/users/${userId}/change-password`, {
    old_password: data.old_password,
    new_password: data.new_password,
  });
  return response.data;
};

export const getUserVisitCount = async (id: string) => {
  const response = await axios.get<{ visit_count: number }>(`/users/${id}/visit-count`);
  return response.data;
};

export const getUserMeetings = async (userId: string) => {
  const response = await axios.get<{ meetings: Meeting[] }>(`/users/${userId}/meetings`);
  return response.data;
};

export const updateUserReferrals = async ({ source }: { source: string }) => {
  const response = await client2.post("/user-refferals", { source });
  return response.data;
};

export const getUserParsedResumeWithAI = async (data: FormData) => {
  const response = await client2.post<ParseResumeResponse>(`ai/parse-resume`, data);
  return response.data;
};

export const updateUserOnboardingPopups = async (userId: string, resume: boolean) => {
  const response = await axios.put(`/users/${userId}/popups`, { popups: { resume } });
  return response.data;
};

export const searchUserByEmail = async (email: string) => {
  const response = await client2.get(`/users/search-by-email?email=${email}`);
  return response.data;
}